export const getters = {
  foundationData: state => {
    return state.mainData.foundation
  },
  gifsLoaded: state => {
    return state.ui.gifsLoaded
  },
  museumData: state => {
    return state.mainData.museum
  },
  centrumData: state => {
    return state.mainData.centrum
  },
  virtualData: state => {
    return state.mainData.virtual
  },
  searchData: state => {
    return state.mainData.search
  },
  productData: state => {
    return state.mainData.product
  },
  footerData: state => {
    return state.mainData.footer
  },
  loaderData: state => {
    return state.mainData.loader
  },
  contactData: state => {
    return state.mainData.contact
  },
  loginData: state => {
    return state.mainData.login
  },
  registerData: state => {
    return state.mainData.register
  },
  errorData: state => {
    return state.mainData.error
  },
  buttonData: state => {
    return state.mainData.button
  },
  dataLoaded (state) {
    return state.dataLoaded
  },
  breakpoint: state => {
    return state.ui.breakpoint
  },
  wWidth: state => {
    return state.ui.windowWidth
  },
  mainNavOpen: state => {
    return state.ui.mainNavOpen
  },
  pageNavOpen: state => {
    return state.ui.pageNavOpen
  },
  disabledScrolls: state => {
    return state.ui.disableScrolls
  },
  fontSize (state) {
    return state.ui.fontSize
  },
  fontSizeMax (state) {
    return state.ui.fontSizeMax
  },
  fontSizeMin (state) {
    return state.ui.fontSizeMin
  },
  contrast (state) {
    return state.ui.contrast
  },
  availableTranslations (state) {
    return state.mainData.settings.availableTranslations
  },
  selectedTranslation (state) {
    return state.mainData.settings.selectedTranslation
  },
  apiPath (state) {
    if (state.mainData.settings.selectedTranslation) {
      return state.apiPath + state.mainData.settings.selectedTranslation + '/'
    }
    return state.apiPath
  },
  apiAuthPath (state) {
    return state.apiAuthPath
  },
  categories (state) {
    return state.categories
  },
  activeCategory (state) {
    if (state.route && state.route.query && state.route.query.category) {
      state.categories.find((el, index) => {
        if (el.name === state.route.query.category) {
          return index
        } else {
          return state.activeCategory
        }
      })
    } else {
      return state.activeCategory
    }
  },
  activeCategoryName (state) {
    if (state.route && state.route.query && state.route.query.kategoria) {
      return state.route.query.kategoria
    } else {
      return state.categories[state.activeCategory].slug
    }
  },
  activeFilters (state) {
    return state.activeFilters
  },
  activeSearch (state) {
    return state.activeSearch
  },
  activeListItem (state) {
    return state.activeListItem
  },
  lastPageName (state) {
    if (state.route && state.route.from && state.route.from.name) {
      return state.route.from.name
    } else {
      return 'menu'
    }
  },
  isLoggedIn (state) {
    return state.isLoggedIn
  },
  getloginErrors (state) {
    return state.loginErrors
  },
  isRegistered (state) {
    return state.isRegistered
  },
  getRegisterErrors (state) {
    return state.registerErrors
  },
  authToken (state) {
    return state.authToken
  },
  currentUser (state) {
    return state.loggedUserId
  },
  isFullscreen (state) {
    return state.isFullscreen
  },
  iframeFullscreen (state) {
    return state.iframeFullscreen
  },
  isNewsletterSignin (state) {
    return state.isNewsletterSignin
  },
  newsletterErrors (state) {
    return state.newsletterErrors
  },
  inClipboard (state) {
    return state.clipboardItems.includes(state.route.params.id)
  }
}
